import React from "react";

import Styles from "./Privacy.styles";
import { PrivacyProps as Props } from "./Privacy.types";
import Footer from "components/global/Footer/Footer";
import GoBack from "components/global/GoBack/GoBack";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import CONSTANTS from "config/constants";
import useI18n from "hooks/useI18n";

const { CUSTOMER_SERVICE_EMAIL } = CONSTANTS.GENERAL;

const Privacy: React.FC<Props> = props => {
  const t = useI18n();

  return (
    <Styles className="Privacy">
      <header className="Privacy__header">
        <Navbar showBrand />
      </header>
      <main className="Privacy__main">
        <ProfileNavigation className="Privacy__profile-navigation" />
        <section className="Privacy__content">
          <GoBack className="Privacy__go-back" title="Atrás" />
          <div className="Privacy__container">
            <h1 className="Privacy__title">{t.terms.privacy}</h1>
            <p className="Privacy__paragraph">
              La presente Política de Privacidad establece los términos en
              virtud de los cuales se usa y protege la información proporcionada
              por los usuarios al momento de utilizar la aplicación móvil
              denominada NOE SUSHI BAR , (en adelante &quot;Plataforma
              Virtual&quot;) que es manejada por SUSHICORP S.A.S (en adelante
              &quot;SUSHICORP&quot;), los cuales contienen las reglas que rigen
              la relación comercial de los consumidores con SUSHICORP,
              especialmente la autorización sobre el uso de la Plataforma
              Virtual a favor de los consumidores y usuarios la plataforma.
            </p>
            <p className="Privacy__paragraph">
              SUSHICORP es una compañía comprometida con el manejo seguro y
              protección de los datos personales de sus usuarios, por lo que
              toda la información recopilada será tratada con los estándares más
              fuertes de protección y privacidad.
            </p>
            <p className="Privacy__paragraph">
              La presente Política de Privacidad está vinculada con los Términos
              y Condiciones del servicio ofertado por SUSHICORP y con la
              Política de Privacidad de la plataforma COMO-SENSE.
            </p>
            <p className="Privacy__paragraph">
              La presente Política de Privacidad puede cambiar con el tiempo o
              ser actualizada, para lo cual el Usuario será debidamente
              informado y notificado, solicitando su confirmación de haber
              revisado las actualizaciones y así poder asegurarnos de que está
              de acuerdo con dichos cambios.
            </p>
            <h3 className="Privacy__subtitle">Acceso a la plataforma</h3>
            <p className="Privacy__paragraph">
              Para el acceso a la Plataforma se requiere la creación voluntaria
              de un perfil por parte del Usuario, lo que implica el conocimiento
              y la aceptación expresa e inequívoca de la Política de Privacidad
              y la Política de Cookies por parte de todos los Usuarios.
            </p>
            <p className="Privacy__paragraph">
              Antes de registrase en la plataforma COMO-SENSE, los Usuarios
              deben leer la presente Política de Privacidad y Protección de
              Datos. Al marcar el botón &quot;registrarse&quot;, los Usuarios
              afirman que han leído y que consienten expresamente las presente
              Política de Privacidad de Datos de la plataforma, en particular la
              finalidad con la que se recopilan los datos, así como cualquier
              cesión de datos prevista en la presente Política de Privacidad.
            </p>
            <p className="Privacy__paragraph">
              Para poder ser usuario de la Plataforma es indispensable que se
              cumplan los siguientes requisitos:
            </p>
            <div className="Privacy__paragraph">
              <ul className="Privacy__list-items">
                <li>Haber cumplido o ser mayor de 18 años de edad.</li>
                <li>
                  Completar de manera veraz los campos obligatorios del
                  formulario de registro, en el que se solicitan datos de
                  carácter personal como nombre de usuario, correo electrónico,
                  número de teléfono y número de tarjeta bancaria.
                </li>
                <li>Aceptar los Términos y Condiciones de uso.</li>
                <li>
                  Aceptar la Política de Privacidad y Protección de Datos.
                </li>
                <li>Aceptar la Política de Cookies.</li>
              </ul>
            </div>
            <p className="Privacy__paragraph">
              El usuario garantiza que todos los datos sobre su identidad son
              legítimos tal y como han sido detallados en sus formularios de
              registro de la Plataforma son veraces, exactos y completos.
              Asimismo, se compromete a mantener actualizados sus datos.
            </p>
            <p className="Privacy__paragraph">
              En el supuesto en que el Usuario facilite cualquier dato falso,
              inexacto o incompleto, se le podrá denegar el acceso y uso
              presente o futuro de la Plataforma o de cualquiera de sus
              contenidos y/o servicios.
            </p>
            <p className="Privacy__paragraph">
              Al darse de alta en la Plataforma, el Usuario seleccionará un
              nombre de usuario (username) y una clave de acceso (password).
              Tanto el username como el password son estrictamente
              confidenciales, personales e intransferibles.
            </p>
            <p className="Privacy__paragraph">
              El Usuario se compromete a no divulgar los datos relativos a su
              cuenta ni hacerlos accesibles a terceros. El Usuario será el único
              responsable en caso de uso de dichos datos por terceros, incluidas
              las manifestaciones vertidas en la Plataforma, o cualquier otra
              actuación que se lleve a cabo mediante el uso del username y/o
              password.
            </p>
            <p className="Privacy__paragraph">
              COMO-SENSE no puede garantizar la identidad de los Usuarios
              registrados, por tanto, no será responsable del uso de la
              identidad de un Usuario registrado por terceros no registrados.
            </p>
            <h3 className="Privacy__subtitle">Datos personales</h3>
            <p className="Privacy__paragraph">
              Para poder completar el registro en la Plataforma el Usuario
              deberá proporcionar algunos datos como: nombre de Usuario,
              dirección de correo electrónico, teléfono, datos de la tarjeta
              bancaria, genero, entre otras. Una vez completado el registro,
              todo Usuario podrá acceder a su perfil y completarlo, y editarlo
              y/o darse de baja según estime conveniente.
            </p>
            <p className="Privacy__paragraph">
              Así mismo cuando sea necesario podrá ser requerida información
              específica para procesar algún pedido o realizar una entrega o
              facturación.
            </p>
            <h3 className="Privacy__subtitle">Uso de la información</h3>
            <p className="Privacy__paragraph">
              La información recopilada por la aplicación COMO-SENSE y todas sus
              herramientas anexas, será utilizada para proporcionar al usuario
              el mejor servicio posible, con respecto a la posibilidad de
              realizar pedidos de sus productos ya sea en modalidad de servicio
              a domicilio o servicio para llevar. El cliente reconoce que los
              productos ofertados en el menú están sujetos a la disponibilidad
              de los mismos en el restaurante. Dicha información será recopilada
              con la finalidad de mantener un registro de usuarios, de pedidos,
              de preferencias de consumo y para mejorar los productos y
              servicios ofertados.
            </p>
            <p className="Privacy__paragraph">
              SUSHICORP podrá enviar correos electrónicos al usuario con ofertas
              especiales, nuevos productos y otra información publicitaria que
              se considere relevante o que pueda brindarle algún beneficio al
              usuario. Dichos correos serán enviados a la dirección electrónica
              proporcionada y podrán ser cancelados en cualquier momento.
            </p>
            <p className="Privacy__paragraph">
              Adicionalmente, la información recopilada podrá ser utilizada, de
              una manera no excluyente, para las siguientes finalidades:
              Compilar la información entregada por el usuario, realizar
              estudios estadísticos, promocionar productos o servicios que
              consideramos puedan ser de interés del usuario, identificar
              preferencias de consumos, determinar tiempos de servicios, evaluar
              la calidad del servicio, dar seguimiento de la experiencia de
              consumo, contactar a los medios de comunicación proporcionados,
              prevenir fraudes, consultar opiniones del usuario, construir una
              relación personalizada, construir una cultura enfocada en las
              necesidades del consumidor, realizar concursos o sorteos,
              identificar fechas festivas personales para ofrecer promociones,
              dar a conocer alianzas estratégicas, realizar pagos de consumos in
              situ, monitorear los datos, enviar noticias, realizar un análisis
              histórico de pedidos, análisis de los importes realizados,
              análisis de la frecuencia de pedidos y tipo de pedidos (delivery o
              pick up) para el mejoramiento del servicio ofertado, recolectar
              promociones utilizadas por el usuario, ofrecer y/o promocionar
              servicios complementarios, envío de códigos promocionales, envío
              de notificaciones para verificación de usos y formas de pago,
              recepción de mensajes de texto, audio o visual, mejora de la
              plataforma web y los aplicativos móviles.
            </p>
            <p className="Privacy__paragraph">
              SUSHICORP está altamente comprometido para cumplir con el
              compromiso de mantener su información segura. La plataforma o
              aplicación COMO-SENSE es segura y basada en los sistemas más
              avanzados, con la finalidad de prevenir cualquier fuga de
              información.
            </p>
            <h3 className="Privacy__subtitle">Usos prohibidos de este sitio</h3>
            <p className="Privacy__paragraph">
              Los Usuarios son completamente responsables del acceso y correcto
              uso de su perfil y demás contenidos de la Plataforma con sujeción
              a la legalidad vigente, sea nacional o internacional del País
              desde el que hace uso de la Plataforma, así como a los principios
              de buena fe, a la moral, buenas costumbres y orden público. Y
              específicamente, adquiere el compromiso de observar diligentemente
              las presentes Condiciones Generales de Uso.
            </p>
            <p className="Privacy__paragraph">
              Los Usuarios se abstendrán de usar su perfil y el resto de
              contenidos de la Plataforma con fines o efectos ilícitos y que
              sean lesivos de los derechos e intereses de terceros, o que de
              cualquier forma puedan dañar, inutilizar, afectar o deteriorar la
              Plataforma, sus contenidos y sus servicios. Asimismo, queda
              prohibido impedir la normal utilización o disfrute de la
              Plataforma a otros Usuarios.
            </p>
            <p className="Privacy__paragraph">
              El Usuario no podrá publicar, contenidos o materiales que:
            </p>
            <div className="Privacy__paragraph">
              <ol type="a" className="Privacy__list-items">
                <li>
                  sean ilegales, obscenos, vulgares, blasfemos, indecentes, con
                  contenidos de sexo explícito, amenazantes, hostigadores,
                  abusivos, ofensivos, o discriminatorios desde el punto de
                  vista racial o étnico, difamatorios, invasivos de derechos de
                  privacidad o de publicidad, violatorios de los derechos de
                  propiedad intelectual, o de otro modo perjudiciales o
                  inaceptables para terceros;
                </li>
                <li>
                  consistan en o contengan virus, archivos dañados, o cualquier
                  otro archivo similar, cuya intención sea perjudicar o alterar
                  el funcionamiento de la plataforma;
                </li>
                <li>
                  contengan información para hacer campañas políticas,
                  publicidad no autorizada, materiales promocionales, u otros
                  métodos de captación de otros usuarios, personas físicas o
                  entidades;
                </li>
                <li>
                  utilicen una dirección de correo electrónico falsa, impliquen
                  hacerse pasar por otra persona o empresa, incluyendo nuestra
                  empresa, así como nuestros empleados o representantes, o que
                  de cualquier otra manera resulten engañosos en cuanto al
                  origen de su contenido;
                </li>
                <li>
                  inciten la realización de conductas que pudieran constituir
                  delito;
                </li>
                <li>den lugar a responsabilidad civil;</li>
                <li>
                  de otro modo violen cualquier disposición legal, derechos de
                  terceros; o
                </li>
              </ol>
            </div>
            <h3 className="Privacy__subtitle">Pagos:</h3>
            <p className="Privacy__paragraph">
              El pago de los productos y/o servicios que se venderán a través de
              la Plataforma, y se entregan a los Clientes de forma diferida, se
              efectúan transitoriamente a COMO-SENSE y éste lo transmite a
              SUSHICORP, quien autoriza a COMO-SENSE a aceptar el pago en su
              nombre.
            </p>
            <p className="Privacy__paragraph">
              Todos los precios que se indican en la Plataforma incluyen los
              impuestos que pudieran ser aplicables en función del territorio y
              en todo caso se expresarán en Dólares de los Estados Unidos de
              Norteamérica.
            </p>
            <h3 className="Privacy__subtitle">Geolocalización</h3>
            <p className="Privacy__paragraph">
              Para el funcionamiento de la plataforma digital, COMO-SENSE podrá
              recoger, utilizar y compartir datos precisos sobre localizaciones,
              incluyendo la localización geográfica en tiempo real del ordenador
              o dispositivo móvil del Usuario, siempre que el Usuario lo
              autorice. Estos datos de localización pueden ser recogidos y
              utilizados para mostrar a los Usuarios la ubicación del origen de
              un encargo y/o la ubicación del origen de destino.
            </p>
            <p className="Privacy__paragraph">
              En este sentido, los Usuarios consienten expresamente que sus
              datos de geolocalización sean compartidos con otros Usuarios y
              Proveedores para poder llevar a éxito el encargo solicitado en
              cada momento.
            </p>
            <p className="Privacy__paragraph">
              Es responsabilidad del Usuario consignar correctamente las
              direcciones de recogida y entrega, COMO-SENSE no se responsabiliza
              de error u omisión en la consignación de las mismas por parte del
              Usuario. El Usuario podrá darse de baja de la Plataforma.
            </p>
            <h3 className="Privacy__subtitle">
              Enlaces a sitios web de terceros
            </h3>
            <p className="Privacy__paragraph">
              La aplicación COMO-SENSE podrá incluir enlaces a otros sitios que
              puedan ser de interés del usuario. Una vez que el usuario haga
              clic en los enlaces y abandone la plataforma COMO-SENSE, SUSHICORP
              ya no tiene control ni responsabilidad sobre la protección de los
              datos personales del usuario. Dichos sitios están sujetos a sus
              propias políticas de privacidad por lo cual es recomendable que
              los consulte para confirmar que está de acuerdo con estas.
            </p>
            <h3 className="Privacy__subtitle">
              Control de su información personal
            </h3>
            <p className="Privacy__paragraph">
              En cualquier momento, el usuario puede consultar sobre los datos
              recopilados y su uso, a través del contacto proporcionado por la
              aplicación. Se podrá solicitar información a través de un
              formulario para esta acción.
            </p>
            <p className="Privacy__paragraph">
              SUSHICORP manejará los datos personales en base a los más
              estrictos estándares de protección y confidencialidad, siempre con
              el consentimiento del titular de los datos y salvo que sea
              requerido por un juez con un orden judicial.
            </p>
            <h3 className="Privacy__subtitle">Propiedad Intelectual:</h3>
            <p className="Privacy__paragraph">
              SUSHICORP es titular o licenciataria de todos los derechos de
              propiedad intelectual e industrial incluidos en la Plataforma. Así
              también, COMO-SENSE es titular de todos los derechos propiedad
              intelectual de la Plataforma, así como: textos, imágenes, diseño
              gráfico, estructura de navegación, información y contenidos que se
              recogen en ella son titularidad de COMO-SENSE, a quien corresponde
              el ejercicio exclusivo de los derechos de explotación de los
              mismos en cualquier forma y, en especial, los derechos de
              reproducción, distribución, comunicación pública y transformación,
              de conformidad con la legislación española de derechos de
              propiedad intelectual e industrial.
            </p>
            <p className="Privacy__paragraph">
              La autorización al Usuario para el acceso a la Plataforma no
              supone renuncia, transmisión, licencia o cesión total ni parcial
              sobre derechos de propiedad intelectual o industrial por parte de
              SUSHICORP ni de COMO-SENSE. No está permitido suprimir, eludir o
              manipular de ningún modo los contenidos de la Plataforma de
              COMO-SENSE.
            </p>
            <p className="Privacy__paragraph">
              Asimismo, está prohibido modificar, copiar, reutilizar, explotar,
              reproducir, comunicar públicamente, hacer segundas o posteriores
              publicaciones, cargar archivos, enviar por correo, transmitir,
              usar, tratar o distribuir de cualquier forma la totalidad o parte
              de los contenidos incluidos en la Plataforma para propósitos
              públicos o comerciales.
            </p>
            <p className="Privacy__paragraph">
              El Usuario que proceda a compartir cualquier tipo de contenido a
              través de la Plataforma, asegura que ostenta los derechos
              necesarios para hacerlo, quedando exento COMO-SENSE de cualquier
              responsabilidad sobre el contenido y legalidad de la información
              ofrecida.
            </p>
            <h3 className="Privacy__subtitle">
              Exención de garantías y limitación de responsabilidad:
            </h3>
            <p className="Privacy__paragraph">
              La plataforma COMO-SENSE, así como toda información, contenido,
              materiales y servicios incluidos en éstos o que de otro modo se
              pongan a su disposición por medio de estos sitios, se proporcionan
              &quot;en las condiciones en que se encuentran&quot; y &quot;en su
              estado de disponibilidad&quot;, excepto que se indique lo
              contrario por escrito. No efectuamos declaraciones ni brindamos
              garantías de ninguna índole en cuanto al funcionamiento de estos
              sitios o respecto de la información, contenidos, materiales o
              servicios incluidos en los presentes o que de otro modo se
              encuentren a su disposición a través de éstos, excepto que se
              especifique lo contrario por escrito. Usted acuerda expresamente
              que la utilización de este sitio será a su exclusivo riesgo.
            </p>
            <p className="Privacy__paragraph">
              No garantizamos que este sitio, información, contenidos,
              materiales o servicios incluidos en los presentes o que de otro
              modo se encuentren a su disposición a través de estos sitios, sus
              servidores, o por medio de correos electrónicos enviados por
              nosotros se encuentren libres de virus u otros elementos
              perjudiciales.
            </p>
            <p className="Privacy__paragraph">
              Bajo ninguna circunstancia asumiremos responsabilidad frente a
              ninguna persona en relación con daños de cualquier tipo que
              deriven del uso de estos sitios o de cualquier información,
              contenidos, materiales (incluyendo software) o servicios incluidos
              en o que de cualquier otra forma se encuentren a su disposición a
              través de estos sitios, incluyendo, sin limitación alguna, daños
              directos, indirectos, incidentales o punitivos, daño emergente,
              lucro cesante, pérdida de ingresos, gastos de sustitución,
              interrupciones de las actividades comerciales, perdida de datos o
              daños derivados del uso de la información o con motivo de basarse
              en dicha información.
            </p>
            <h3 className="Privacy__subtitle">
              Otros términos y condiciones, modificación del sitio y
              divisibilidad:
            </h3>
            <p className="Privacy__paragraph">
              Cualquier cambio en la presente Política de Privacidad será
              comunicado a través de la aplicación COMO-SENSE. El uso que el
              usuario realice de los sitios luego de haber sido notificado de
              las modificaciones, será considerado e interpretado como una
              aceptación y reconocimiento de su parte respecto de dichas
              modificaciones.
            </p>
            <p className="Privacy__paragraph">
              En el supuesto que alguna disposición de esta Política de
              Privacidad fuera declarada nula o inaplicable por cualquier
              motivo, se considerará que dicha disposición es divisible y no
              afectará la validez y exigibilidad de las restantes disposiciones
              y el Contrato en su totalidad.
            </p>
            <h3 className="Privacy__subtitle">Legislación aplicable:</h3>
            <p className="Privacy__paragraph">
              Al registrarse en la aplicación COMO-SENSE, el usuario acepta la
              presente Política de Privacidad y las controversias de cualquier
              índole que surgieren entre la plataforma COMO-SENSE y el Usuario,
              se regirán por las leyes de la República del Ecuador.
            </p>
            <h3 className="Privacy__subtitle">Controversias:</h3>
            <p className="Privacy__paragraph">
              Cualquier controversia generada con el usuario se someterá a
              arbitraje definitivo y vinculante, el cual constituye el único y
              exclusivo recurso para solucionar la controversia o conflicto.
            </p>
            <p className="Privacy__paragraph">
              Al acordar someterse a arbitraje, cada parte renuncia a su derecho
              de recurrir a la justicia ordinaria y en general a un tribunal y
              hacer que la disputa sea considerada por un juez o jurado.
              Cualquier reclamo que deba someterse a arbitraje deberá efectuarse
              a través de la presentación de una demanda de arbitraje dentro de
              un (1) año a partir del primer hecho que haya originado el
              reclamo. El derecho y el deber de las partes de resolver sus
              controversias a través de un arbitraje, deberá ser administrado
              exclusivamente por Cámara de Comercio de Quito de conformidad con
              sus Reglas y Procedimientos Integrales de Arbitraje vigentes en
              ese momento. La decisión y laudo del árbitro tendrá carácter
              definitivo y vinculante y el laudo podrá ser registrado ante
              cualquier tribunal competente. El proceso arbitral se llevará a
              cabo en Derecho y se considerará que el laudo se dictará en
              derecho conforme a la legislación vigente del Ecuador. Cada parte
              deberá soportar sus propios costos y gastos del proceso arbitral,
              con excepción de los honorarios del árbitro, los cuales serán
              soportados por las partes en porcentajes iguales. El árbitro
              carecerá de facultad para reformar o modificar estos Términos o
              bien ordenar la reparación de daños punitivos o ejemplares.
            </p>
            <h3 className="Privacy__subtitle">Contacto:</h3>
            <p className="Privacy__paragraph">
              Para cualquier información adicional, requerimiento o solicitud,
              el usuario podrá ponerse en contacto con SUSHICORP a través de la
              siguiente dirección de correo electrónico:{" "}
              {CUSTOMER_SERVICE_EMAIL}
            </p>
          </div>
        </section>
      </main>
      <footer className="Privacy__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

Privacy.defaultProps = {};

export default Privacy;
